// Magia de webpack para hacer el import de todos los command/commands y que se registren
// M�s info aqu�: https://webpack.js.org/guides/dependency-management/#require-context

function importAll(r: any) {
	r.keys().forEach(r);
}

importAll((require as any).context('./', true, /Commands?\.tsx?$/));

export { };
